import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
  Home,
  Clock,
  Settings,
  Zap,
  LogOut,
  X,
  MessageSquare,
  Music,
  Scissors,
  BarChart2,
  HelpCircle,
  FileText,
  PanelLeftClose,
  PanelLeft,
  Download,
  Video,
  Mic,
  Youtube
} from 'lucide-react';
import logo from '../assets/logo.png';

export const Sidebar = ({ onSignOut, isOpen, onClose, collapsed, onToggleCollapse, profile }) => {
  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'open' : ''}`} onClick={onClose} />
      <aside className={`sidebar ${isOpen ? 'open' : ''} ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <Link to="/">
              <img src={logo} alt="Logo" className="sidebar-logo" />
            </Link>
          </div>
          <button
            className="sidebar-collapse-btn"
            onClick={onToggleCollapse}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? <PanelLeft size={18} /> : <PanelLeftClose size={18} />}
          </button>
          <button
            className="mobile-close-btn"
            onClick={onClose}
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-group">
            {!collapsed && <span className="group-label">Tools</span>}
            <NavLink to="/smart-clips" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={onClose} end title="Smart Clips">
              <Video size={20} />
              {!collapsed && <span>Smart Clips</span>}
            </NavLink>
            <NavLink to="/ranking" className="sidebar-link" onClick={onClose} title="Ranked">
              <BarChart2 size={20} />
              {!collapsed && <span>Ranked</span>}
            </NavLink>
            <NavLink to="/rant-creator" className="sidebar-link" onClick={onClose} title="Rants">
              <MessageSquare size={20} />
              {!collapsed && <span>Rants</span>}
            </NavLink>
            <NavLink to="/quiz-creator" className="sidebar-link" onClick={onClose} title="Quizzes">
              <HelpCircle size={20} />
              {!collapsed && <span>Quizzes</span>}
            </NavLink>
            <NavLink to="/voice-clone" className="sidebar-link" onClick={onClose} title="Voice Clone">
              <Mic size={20} />
              {!collapsed && <span>Voice Lab</span>}
            </NavLink>
            <NavLink to="/youtube" className="sidebar-link" onClick={onClose} title="YouTube Studio">
              <Youtube size={20} />
              {!collapsed && <span>YouTube Studio</span>}
            </NavLink>
            <NavLink to="/downloader" className="sidebar-link" onClick={onClose} title="Downloader">
              <Download size={20} />
              {!collapsed && <span>Downloader</span>}
            </NavLink>
            <NavLink to="/video-splitter" className="sidebar-link" onClick={onClose} title="Splitter">
              <Scissors size={20} />
              {!collapsed && <span>Splitter</span>}
            </NavLink>
            <NavLink to="/audio-converter" className="sidebar-link" onClick={onClose} title="Converter">
              <Music size={20} />
              {!collapsed && <span>Converter</span>}
            </NavLink>
          </div>

          <div className="nav-group">
            {!collapsed && <span className="group-label">Library</span>}
            <NavLink to="/projects" className="sidebar-link" onClick={onClose} title="My Projects">
              <FileText size={20} />
              {!collapsed && <span>My Projects</span>}
            </NavLink>
            <NavLink to="/trending" className="sidebar-link" onClick={onClose} title="Trending">
              <Zap size={20} />
              {!collapsed && <span>Trending</span>}
            </NavLink>
            <NavLink to="/history" className="sidebar-link" onClick={onClose} title="History">
              <Clock size={20} />
              {!collapsed && <span>History</span>}
            </NavLink>
          </div>

          <div className="nav-group">
            {!collapsed && <span className="group-label">Preferences</span>}
            <NavLink to="/settings" className="sidebar-link" onClick={onClose} title="Settings">
              <Settings size={20} />
              {!collapsed && <span>Settings</span>}
            </NavLink>
          </div>
        </nav>

        {profile && profile.usage && (
          <div className={`sidebar-credits ${collapsed ? 'collapsed' : ''}`} style={{
            padding: collapsed ? '10px 0' : '15px',
            borderTop: '1px solid rgba(255,255,255,0.1)',
            marginBottom: '10px'
          }}>
            {!collapsed ? (
              <div className="credit-balance-box" style={{
                background: 'rgba(255,255,255,0.05)',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                <div style={{ fontSize: '0.75rem', color: '#888', marginBottom: '4px' }}>Available Credits</div>
                <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#fff', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span>🪙</span>
                  {profile.usage.credits?.toLocaleString() || 0}
                </div>
                <Link to="/settings" onClick={onClose} style={{
                  display: 'block',
                  marginTop: '8px',
                  fontSize: '0.8rem',
                  color: '#3b82f6',
                  textDecoration: 'none'
                }}>
                  + Top Up
                </Link>
              </div>
            ) : (
              <div title={`Credits: ${profile.usage.credits?.toLocaleString() || 0}`} style={{ textAlign: 'center', fontSize: '1.2rem' }}>
                🪙
              </div>
            )}
          </div>
        )}

        <div className="sidebar-footer">
          <button onClick={onSignOut} className="logout-btn sidebar-link" title="Sign Out">
            <LogOut size={20} />
            {!collapsed && <span>Sign Out</span>}
          </button>
        </div>
      </aside>
    </>
  );
};
